import { render, staticRenderFns } from "./notifications.vue?vue&type=template&id=705e6b9b&scoped=true"
import script from "./notifications.vue?vue&type=script&lang=js"
export * from "./notifications.vue?vue&type=script&lang=js"
import style0 from "./notifications.vue?vue&type=style&index=0&id=705e6b9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705e6b9b",
  null
  
)

export default component.exports